import { LegTerms } from '../../../../../../models/LegTerms';

export const empty_leg_terms: LegTerms = {
  leg_type_id: 1,
  pay_receive_id: 1,
  currency_id: 1,
  transaction_leg_id: null,
  notional: null,
  current_notional_leg: false,
  collateral_currency: null,
  discounting_index_id: null,
  day_count_id: null,
  calculation_calendar: null,
  reset_calendar: null,
  // Notional Exchange Fields
  toggle_notional_exchange_fields_flag: false,
  initial_notional_exchange: false,
  intermediary_notional_exchange: false,
  final_notional_exchange: false,
  // Dates
  effective_date: null,
  maturity_date: null,
  pay_frequency: null,
  expiry_date: null,
  first_payment_date: null,
  next_to_last_payment_date: null,
  payment_offset: 0,
  business_day_convention: null,
  // Fixed Leg Fields
  coupon: null,
  // Floating Leg Fields
  forecasting_index_id: null,
  spread: null,
  // Cap Floor Fields
  strike: null,
  toggle_roll_fields_flag: false,
  eom_roll: true,

  calc_basis_id: null,
  volatility: null,
  calendar_currencies: null,
  //required for build
  inflation_lag: null,
  settlement_date: null,
  //For reports
  rounding_decimals: 6,
  //
  compounding_coupon: null,
  save_coupon: false,
};
